(function processDefinition() {
    'use strict';
    angular.module('Entities')
        .service('processBatchService', [
            'restUrlBuilder', '$injector', 'config', 'authExtend', function processBatchService(restUrlBuilder, $injector, config, authExtend) {

                var processBuilder = restUrlBuilder('process');

                this.get = function get(find) {
                    var params = {
                        OrganizationalUnitId: find.ouId,
                        Name: find.name,
                        orderBy: find.orderBy
                    };

                    return processBuilder.all('processes').get({ params: params });
                };

                this.getById = function getById(id) {

                    return processBuilder.one('processes', id).get();
                };

                this.getHistory = function getHistory(params) {
                    return processBuilder.all('ProcessLogs/ByProcess').get({ params: params });
                };

                this.advancedGet = function advancedGet(params) {

                    return processBuilder.all('processes/find').put(params);
                };

                this.getProcessTypes = function getProcessTypes() {

                    return processBuilder.all('processTypes').get();
                };

                this.getProcessStates = function getProcessStates() {

                    return processBuilder.all('processStates').get();
                };

                this.create = function (process, files) {

                    var $upload = $injector.get('Upload');
                    if ($upload === null) {
                        throw "No se pudo instanciar $upload. Verifique que se cargó el script ng-file-upload";
                    }

                    return $upload.upload({
                        url: processBuilder.all('Processes').url,
                        method: 'POST',
                        fields: { process: JSON.stringify(process) },
                        file: files,
                        fileFormDataName: 'imageFile'
                    });
                };
            }
        ]);
})();